import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import React from "react";

function EmptyTransparentCard({ children, careers, lend, outline }) {
  const classes = useStyles();

  const childrenWithProps = React.Children.map(children, (child) => {
    // Checking isValidElement is the safe way and avoids a typescript
    // error too.
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { outline });
    }
    return child;
  });

  return (
    <Box
      className={`${classes.root} shadow-xl`}
      style={
        careers
          ? { width: "280px", height: "380px", margin: "20px auto" }
          : lend
          ? {
              // width: "180px",

              // margin: "20px auto",
              minHeight: "150px",
              marginRight: "15px",
              marginLeft: "15px",
              border: outline ? "2px solid #3AC4AB" : "2px solid transparent",
            }
          : { width: "331px", height: "330px", margin: "20px auto" }
      }
    >
      {childrenWithProps}
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    // height: "330px",
    // width: "331px",
    // margin: "20px",
    padding: "10px",

    // boxShadow:
    //   theme.palette.type === "dark"
    //     ? "0px 4px 4px rgba(0, 0, 0, 0.25), 40px 60px -100px rgba(16, 18, 26, 0.5)"
    //     : "0px 4px 8px rgba(0, 0, 0, 0.12)",
    // boxShadow:
    //   theme.palette.type === "dark"
    //     ? "40px 60px 200px rgba(16, 18, 26, 0.5)"
    //     : "6px 4px 12px -1px rgba(109, 227, 206, 0.2)",
    borderRadius: "24px",
    background:
      theme.palette.type === "dark"
        ? "radial-gradient(98.09% 98.09% at 31.51% 23.05%, rgba(75, 80, 94, 0.5) 0%, rgba(36, 38, 43, 0.5) 100%)"
        : "#ffffff",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",

    [theme.breakpoints.down("md")]: {
      margin: "20px",
      height: "auto",
      paddingBottom: "20px",
    },
    transition: "all .4s ease-in-out",
    // "&:hover": {
    //   [theme.breakpoints.down("sm")]: {
    //     transform: "scale(1.05,1.05)",
    //   },
    //   transform: "scale(1.15,1.15)",
    // },
  },
}));

export default EmptyTransparentCard;
